import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { addPdfPageNumberFooter } from "../../utils/pdf-page-footer";
import { CustomerDeliveryReport } from "../../models/Delivery-Executive/DeliveryExecutive";
import orderServices from "../../services/orders/orderservice";
 
export const exportCustomerDeliveryReport = async () => {
  try {
    const response = await orderServices.getCustomerDeliveryReport();
    if (!response) {
      console.warn("No data received for Customer Delivery Report.");
      return;
    }
    await generatePDFCustomerDelivery(response);
  } catch (error) {
    console.error("Error fetching Customer Delivery Report:", error);
    throw error;
  }
};
 
export const generatePDFCustomerDelivery = async (
  reportList: CustomerDeliveryReport[],
  loadInstructions: typeof orderServices.getOrderInstructions = orderServices.getOrderInstructions
) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });
 
  const tableData: any[] = [];
 
  for (const order of reportList) {
    const instructionsResponse = await loadInstructions(order.orderId);
    const customerInstructionText =
      instructionsResponse?.instructions
        ?.filter((x: any) => x.instructionType === "CI")
        .map((x: any) => x.instruction)
        .filter((val: string) => !!val)
        .join("\n") || "";
    const deliveryInstructionText =
      instructionsResponse?.instructions
        ?.filter((x: any) => x.instructionType === "DI")
        .map((x: any) => x.instruction)
        .filter((val: string) => !!val)
        .join("\n") || "";
    const osiInstructionText =
      instructionsResponse?.orderComments ||
      instructionsResponse?.instructions
        ?.filter((x: any) => x.instructionType === "OSI" || x.instructionType === "OI")
        .map((x: any) => x.instruction)
        .filter((val: string) => !!val)
        .join("\n") || "";

    const flagInstructionText = String(order.latestFlagInstruction ?? '').trim();

    let totalQty = 0;
    let totalAmount = 0;
 
    if (order.products && order.products.length > 0) {
      order.products.forEach((product, index) => {
        totalQty += product.quantity;
        totalAmount += product.productAmount || 0;
        tableData.push([
          index === 0 ? order.sequenceNo : "",
          index === 0 ? order.orderId : "",
          index === 0 ? order.customerContact : "",
          index === 0 ? order.customerName : "",
          index === 0
            ? `${order.address1 ?? ""}, ${order.address2 ?? ""}, ${
                order.landmark ?? ""
              }, ${order.areaName}, ${order.subDistrictName} ${
                order.districtName
              } ${order.zipcode}`
            : "",
          index === 0 ? order.paymentMode || "" : "",
          index === 0 ? order.paymentStatus || "" : "",
          product.productName,
          product.quantity,
          Math.round(Number(product.productAmount)) || 0,
        ]);
      });
    } else {
      tableData.push([
        order.sequenceNo,
        order.orderId,
        order.customerContact,
        order.customerName,
        `${order.address1 ?? ""}, ${order.address2 ?? ""}, ${
          order.landmark ?? ""
        }, ${order.areaName}, ${order.subDistrictName} ${
          order.districtName
        } ${order.zipcode}`,
        order.paymentMode || "",
        order.paymentStatus || "",
        "",
        "",
        "",
      ]);
    }

    tableData.push([
      "Total",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      totalQty,
      Math.round(Number(totalAmount)) || 0
    ]);

    if (osiInstructionText) {
      tableData.push([
        "",
        "",
        "",
        "OSI",
        osiInstructionText,
        "",
        "",
        "",
        "",
        "",
      ]);
    }

    if (deliveryInstructionText) {
      tableData.push([
        "",
        "",
        "",
        "DI",
        deliveryInstructionText,
        "",
        "",
        "",
        "",
        "",
      ]);
    }

    if (customerInstructionText) {
      tableData.push([
        "",
        "",
        "",
        "CI",
        customerInstructionText,
        "",
        "",
        "",
        "",
        "",
      ]);
    }

    if (flagInstructionText) {
      tableData.push(["", "", "", "FI", flagInstructionText, "", "", "", "", ""]);
    }
  }
 
  autoTable(doc, {
    head: [
      [
        "Sq#",
        "Order#",
        "Mobile#",
        "Customer Name",
        "Address",
        "Order Payment Type",
        "Order Payment Status",
        "Product Name",
        "Quantity",
        "Total Value",
      ],
    ],
    body: tableData,
    styles: { fontSize: 8, cellPadding: 1 },
    headStyles: { fillColor: [41, 128, 185] },
    columnStyles: {
      3: { cellWidth: 18 },
      4: { cellWidth: 62 },
      7: { cellWidth: 50 },
      9: { cellWidth: 22 },
    },
    didParseCell: function (data) {
      if (data.cell.raw === "Total") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 9;
      }
      if (data.row.cells[0]?.raw === "Total") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 9;
      }

      const rowRaw = data.row.raw as any;
      const label = String(
        (Array.isArray(rowRaw) ? rowRaw[3] : undefined) ??
        data.row.cells[3]?.raw ??
        ""
      ).trim();

      const isInstruction =
        label === "DI" ||
        label === "FI" ||
        label === "CI" ||
        label === "OSI" ||
        label.startsWith("CI") ||
        label.startsWith("OSI");

      const isInstructionRow =
        isInstruction &&
        (!rowRaw || (!rowRaw[0] && !rowRaw[1] && !rowRaw[7]));

      if (isInstructionRow) {
        if (data.column.index === 3) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fontSize = 10;
          data.cell.styles.fillColor = [255, 243, 205];
        }
        if (data.column.index === 4) {
          data.cell.styles.fontStyle = "normal";
          data.cell.styles.fontSize = 10;
          data.cell.styles.fillColor = [255, 243, 205];
        }
      }
    },
  });
 
  addPdfPageNumberFooter(doc);
  doc.save("CustomerDeliveryReport.pdf");
};
